import { IFileService } from 'monaco-editor/esm/vs/platform/files/common/files.js';
import { refineServiceDecorator } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
const IWorkbenchFileService = refineServiceDecorator(IFileService);
export { IWorkbenchFileService };
